import {AdvanceTermFilter, ExistFilter, OperatorFilter, TermFilter} from '@dofleini/query-builder';
import {Checkbox, Form} from 'antd';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, {useCallback, useMemo} from 'react';

import FilterContent from '@/components/TableFilters/components/FilterContent';

const BOOL_ENUM = {
  TRUE: 'true',
  FALSE: 'false',
};

export const ExistComponent = ({t, applyFilter, filter, currentValue = []}) => {
  const options = useMemo(() => map(BOOL_ENUM, value => ({value, label: filter[`${value}Text`]})), [filter]);

  const onFinish = useCallback(({value: values}) => {
    if (isEmpty(values))
      return;

    const filters = map(values, value => {
      switch (value) {
        case BOOL_ENUM.TRUE:
          return new OperatorFilter({
            type: 'AND',
            filters: [
              new ExistFilter({field: filter.field, value: true}),
              new AdvanceTermFilter({type: 'NE', field: filter.field, value: null}),
            ]
          }).toQuery();
        case BOOL_ENUM.FALSE:
        default:
          return new OperatorFilter({
            type: 'OR',
            filters: [
              new ExistFilter({field: filter.field, value: false}),
              new TermFilter({field: filter.field, value: null}),
            ]
          }).toQuery();
      }
    });
    return applyFilter({type: 'OR', filters});
  }, [applyFilter, filter.field]);

  return (
    <Form onFinish={onFinish}>
      <FilterContent t={t}>
        <Form.Item name="value" className="m-0" initialValue={currentValue?.map(e => '' + e) || []}>
          <Checkbox.Group className="w-full">
            <div className="w-full flex flex-col max-h-300px">
              {
                options.map(({value, label}) => (
                  <Checkbox className={classNames('mx-0 my-px p-2')} key={value} value={value}>
                    {t(label)}
                  </Checkbox>
                ))
              }
            </div>
          </Checkbox.Group>
        </Form.Item>
      </FilterContent>
    </Form>
  );
};

ExistComponent.propTypes = {
  filter: PropTypes.object,
  currentValue: PropTypes.array,
  t: PropTypes.func,
  applyFilter: PropTypes.func,
};

export const ValueExist = ({filterValue, t, filter}) => {
  const options = useMemo(() => map(filterValue.filters,
    ({filters}) => {
      const value = filters?.some((x) => x?.type === 'EXISTS' && x?.value === true);
      const text = filter[`${String(value)}Text`];
      return t(text);
    }).join(', '), [filterValue.filters, filter, t]);

  return <p className="m-0 break-world leading-snug whitespace-pre-wrap">{options}</p>;
};

ValueExist.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  filterValue: PropTypes.any,
};
